// @flow
import React from 'react'
import styled from 'styled-components'
import { media } from 'src/theme/style-utils'
import { Logo } from 'src/components/Icons'

const LandingNav = () => (
  <LandingNav.Wrapper id="landing_nav_header">
    <LandingNav.Ele>
      <Logo />
      <LandingNav.Text>The Collective application form</LandingNav.Text>
    </LandingNav.Ele>
  </LandingNav.Wrapper>
)

LandingNav.Wrapper = styled.div`
  width: 100vw;
  height: 60px;
  box-shadow: inset 0 -1px 0 0 #e1e4e9;
  background-color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  padding: 0;
  margin: auto;
  top: 0;
  z-index: 1;
`

LandingNav.Ele = styled.div`
  width: 100%;
  max-width: 1200px;
  display: flex;
  padding: 0 10px;
  justify-content: flex-start;
  align-items: center;
  ${media.tabletLarge`
    padding: 0 60px;
  `}
  ${media.desktop`
    padding: 0 60px;
  `};
`

LandingNav.Text = styled.p`
  font-size: 16px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: 0.32px;
  color: black;
  margin-left: 10px;
`

export default LandingNav



// WEBPACK FOOTER //
// ./src/components/NavBar/LandingNav.js